var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-toggle',
    ("dp-toggle--size-" + _vm.size)
  ]},_vm._l((_vm.options),function(option){return _c('button',{key:option.value,class:[
      'dp-toggle__option',
      ("dp-toggle__option--size-" + _vm.size),
      {
        'dp-toggle__option--selected': _vm.value === option.value,
        'dp-toggle__option--disabled': option.disabled,
      } ],attrs:{"disabled":option.disabled},on:{"click":function($event){return _vm.selectOption(option)}}},[_c('dp-tooltip',{staticClass:"dp-toggle__option-inner",attrs:{"tooltip":option.tooltip}},[(option.icon)?_c('dp-icon',{staticClass:"dp-toggle__option-icon",attrs:{"name":option.icon}}):_vm._e(),(option.label)?_c('span',{staticClass:"dp-toggle__option-label"},[_vm._v(" "+_vm._s(option.label)+" ")]):_vm._e()],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }